<template>
    <div class='page'>
        <!-- 搜索 -->
        <el-form v-if='isSearch' :model='queryForm' ref='form' label-width='80px' :inline='true' size='small'
                 class='query-form' @submit.native.prevent>
            <el-form-item label='货币名称'>
                <el-input v-model='queryForm.currencyName'></el-input>
            </el-form-item>
            <el-form-item label='货币logo'>
                <el-input v-model='queryForm.currencyLogo'></el-input>
            </el-form-item>
            <el-form-item label='货币类型'>
                <el-input v-model='queryForm.currencyType'></el-input>
            </el-form-item>
            <el-form-item label='币货汇率'>
                <el-input v-model='queryForm.currencyRatio'></el-input>
            </el-form-item>
            <el-form-item label='币货单位'>
                <el-input v-model='queryForm.currencyUnit'></el-input>
            </el-form-item>
            <el-form-item label='可以充值'>
                <el-input v-model='queryForm.canRecharge'></el-input>
            </el-form-item>
            <el-form-item label='可以提现'>
                <el-input v-model='queryForm.canWithdraw'></el-input>
            </el-form-item>
            <el-form-item label='可以支付'>
                <el-input v-model='queryForm.canPay'></el-input>
            </el-form-item>
            <el-form-item label='可以转账'>
                <el-input v-model='queryForm.canTransfer'></el-input>
            </el-form-item>
            <el-form-item label='可以收款'>
                <el-input v-model='queryForm.canAccept'></el-input>
            </el-form-item>
            <el-form-item label='可以兑出'>
                <el-input v-model='queryForm.canSwapout'></el-input>
            </el-form-item>
            <el-form-item label='可以兑入'>
                <el-input v-model='queryForm.canSwapin'></el-input>
            </el-form-item>
            <el-form-item label='提现手续费'>
                <el-input v-model='queryForm.withdrawServicefee'></el-input>
            </el-form-item>
            <el-form-item label='提现限制'>
                <el-input v-model='queryForm.withdrawLimit'></el-input>
            </el-form-item>
            <el-form-item label='转出手续费'>
                <el-input v-model='queryForm.transferServicefee'></el-input>
            </el-form-item>
            <el-form-item label='转出限制'>
                <el-input v-model='queryForm.transferLimit'></el-input>
            </el-form-item>
            <el-form-item label='兑换手续费'>
                <el-input v-model='queryForm.swapServicefee'></el-input>
            </el-form-item>
            <el-form-item label='兑换限制'>
                <el-input v-model='queryForm.swapLimit'></el-input>
            </el-form-item>
            <el-form-item label='字段名称'>
                <el-input v-model='queryForm.fieldName'></el-input>
            </el-form-item>
            <el-form-item label='是否是释放货币'>
                <el-input v-model='queryForm.isRelease'></el-input>
            </el-form-item>
            <el-form-item label='隔间小时数'>
                <el-input v-model='queryForm.intervalHour'></el-input>
            </el-form-item>
            <el-form-item label='释放到哪个货币类型里面'>
                <el-input v-model='queryForm.releaseTo'></el-input>
            </el-form-item>
            <el-form-item>
                <el-button size='small' type='primary' icon='el-icon-search' @click='getMppCurrencyList'>查询
                </el-button>
                <el-button size='small' icon='el-icon-refresh' @click='resetDialog'>重置</el-button>
            </el-form-item>
        </el-form>
        <div class='page-content'>
            <div class='page-tool-bar'>
                <div class='el-btn-group'>
                    <el-button
                        type='primary'
                        size='small'
                        icon='el-icon-plus'
                        @click='addMppCurrency'
                    >新建
                    </el-button>
                    <el-button
                        type='warning'
                        plain
                        size='small'
                        icon='el-icon-edit'
                        :disabled='multipleSelection.length != 1'
                        @click='editMppCurrency(null)'
                    >修改
                    </el-button>
                    <el-button
                        type='danger'
                        plain
                        size='small'
                        icon='el-icon-delete'
                        :disabled='multipleSelection.length <= 0'
                        @click='deleteMppCurrency(null)'
                    >删除
                    </el-button>
                </div>

                <div class='icon-group'>
                    <el-upload v-if='this.isImportDate'
                               class='upload-demo'
                               action='#'
                               :http-request='upload'
                               :show-file-list='true'>
                        <el-button size='small' type='primary'>点击上传</el-button>
                        <div slot='tip' class='el-upload__tip'>只允许导入“xls”或“xlsx”格式文件！</div>
                    </el-upload>
                    <!--        <span-->
                    <!--          title="搜索"-->
                    <!--          class="icon-box"-->
                    <!--          @click="search"-->
                    <!--        >-->
                    <!--          <Icon color="#606266">-->
                    <!--            <Search />-->
                    <!--          </Icon>-->
                    <!--        </span>-->
                    <!--        <span-->
                    <!--          title="下载模板"-->
                    <!--          class="icon-box"-->
                    <!--          @click="importTemplate"-->
                    <!--        >-->
                    <!--          <Icon color="#606266">-->
                    <!--            <ArrowDown />-->
                    <!--          </Icon>-->
                    <!--        </span>-->
                    <!--        <span-->
                    <!--          class="icon-box"-->
                    <!--          title="导入数据"-->
                    <!--          @click="isImport"-->
                    <!--        >-->
                    <!--          <Icon color="#606266">-->
                    <!--            <ArrowExportUp24Regular />-->
                    <!--          </Icon>-->
                    <!--        </span>-->
                    <!--        <span-->
                    <!--          title="导出数据"-->
                    <!--          class="icon-box"-->
                    <!--          @click="exportMppCurrencyList"-->
                    <!--        >-->
                    <!--          <Icon color="#606266">-->
                    <!--            <ArrowDownload24Regular />-->
                    <!--          </Icon>-->
                    <!--        </span>-->
                    <span
                        class='icon-box'
                        @click='refreshMppCurrencyList'
                    >
          <Icon color='#606266'>
            <Refresh />
          </Icon>
        </span>
                </div>
            </div>
            <!-- 列表数据 -->
            <el-table
                height='100%'
                :data='mppCurrencyList'
                row-key='id'
                border
                :header-row-style="{height: '10px'}"
                :header-cell-style="{padding: '10px'}"
                :row-style="{height: '9px'}"
                :cell-style="{padding: '9px'}"
                @selection-change='handleSelectionChange'
                size='small'
            >
                <el-table-column
                    align='center'
                    type='selection'
                    width='60'
                ></el-table-column>
                <el-table-column
                    :show-overflow-tooltip='true'
                    align='center'
                    prop='currencyName'
                    label='货币名称'
                    width='180'
                ></el-table-column>
                <el-table-column

                    align='center'
                    prop='currencyLogo'
                    label='货币logo'
                    width='140'
                >
                    <template slot-scope='scope'>
                        <div v-if='scope.row.currencyLogo'>
                            <el-image
                                @click='updateSrcList(scope.row.currencyLogo)'
                                style='width: 30px; height: 30px'
                                :src='scope.row.currencyLogo'
                                :preview-src-list='srcList'
                            ></el-image>
                        </div>
                        <div v-else>--</div>
                    </template>
                </el-table-column>
                <el-table-column
                    :show-overflow-tooltip='true'
                    align='center'
                    prop='currencyType'
                    label='货币数值'
                    width='180'
                ></el-table-column>
                <el-table-column
                    :show-overflow-tooltip='true'
                    align='center'
                    prop='currencyRatio'
                    label='币货汇率'
                    width='180'
                ></el-table-column>
                <el-table-column
                    :show-overflow-tooltip='true'
                    align='center'
                    prop='currencyUnit'
                    label='币货单位'
                    width='180'
                ></el-table-column>
                <el-table-column
                    :show-overflow-tooltip='true'
                    align='center'
                    prop='canRecharge'
                    label='可以充值'
                    width='180'
                >
                    <template scope='scope'>
                        <div>{{ yesNoStatusString(scope.row.canRecharge) }}</div>
                    </template>
                </el-table-column>


                <el-table-column
                    :show-overflow-tooltip='true'
                    align='center'
                    prop='canWithdraw'
                    label='可以提现'
                    width='180'
                >
                    <template scope='scope'>
                        <div>{{ yesNoStatusString(scope.row.canWithdraw) }}</div>
                    </template>
                </el-table-column>
                <el-table-column
                    :show-overflow-tooltip='true'
                    align='center'
                    prop='canPay'
                    label='可以支付'
                    width='180'
                >
                    <template scope='scope'>
                        <div>{{ yesNoStatusString(scope.row.canPay) }}</div>
                    </template>
                </el-table-column>
                <el-table-column
                    :show-overflow-tooltip='true'
                    align='center'
                    prop='canTransfer'
                    label='可以转账'
                    width='180'
                >
                    <template scope='scope'>
                        <div>{{ yesNoStatusString(scope.row.canTransfer) }}</div>
                    </template>
                </el-table-column>
                <el-table-column
                    :show-overflow-tooltip='true'
                    align='center'
                    prop='canAccept'
                    label='可以收款'
                    width='180'
                >
                    <template scope='scope'>
                        <div>{{ yesNoStatusString(scope.row.canAccept) }}</div>
                    </template>
                </el-table-column>
                <el-table-column
                    :show-overflow-tooltip='true'
                    align='center'
                    prop='canSwapout'
                    label='可以兑出'
                    width='180'
                >
                    <template scope='scope'>
                        <div>{{ yesNoStatusString(scope.row.canSwapout) }}</div>
                    </template>
                </el-table-column>
                <el-table-column
                    :show-overflow-tooltip='true'
                    align='center'
                    prop='canSwapin'
                    label='可以兑入'
                    width='180'
                >
                    <template scope='scope'>
                        <div>{{ yesNoStatusString(scope.row.canSwapin) }}</div>
                    </template>
                </el-table-column>
                <el-table-column
                    :show-overflow-tooltip='true'
                    align='center'
                    prop='withdrawServicefee'
                    label='提现手续费'
                    width='180'
                ></el-table-column>
                <el-table-column
                    :show-overflow-tooltip='true'
                    align='center'
                    prop='withdrawLimit'
                    label='最低提现限制'
                    width='180'
                ></el-table-column>
                <el-table-column
                    :show-overflow-tooltip='true'
                    align='center'
                    prop='transferServicefee'
                    label='转出手续费'
                    width='180'
                ></el-table-column>
                <el-table-column
                    :show-overflow-tooltip='true'
                    align='center'
                    prop='transferLimit'
                    label='转出限制'
                    width='180'
                ></el-table-column>
                <el-table-column
                    :show-overflow-tooltip='true'
                    align='center'
                    prop='swapServicefee'
                    label='兑换手续费'
                    width='180'
                ></el-table-column>
                <el-table-column
                    :show-overflow-tooltip='true'
                    align='center'
                    prop='swapLimit'
                    label='兑换限制'
                    width='180'
                ></el-table-column>
                <el-table-column
                    :show-overflow-tooltip='true'
                    align='center'
                    prop='fieldName'
                    label='字段名称'
                    width='180'
                ></el-table-column>
                <el-table-column
                    :show-overflow-tooltip='true'
                    align='center'
                    prop='isRelease'
                    label='是否是释放货币'
                    width='180'
                >
                    <template scope='scope'>
                        <div>{{ yesNoStatusString(scope.row.isRelease) }}</div>
                    </template>
                </el-table-column>
                <el-table-column
                    :show-overflow-tooltip='true'
                    align='center'
                    prop='releaseMode'
                    label='释放模式'
                    width='180'
                >
                    <template scope='scope'>
                        <div>{{ releaseModeStatusString(scope.row.releaseMode) }}</div>
                    </template>
                </el-table-column>
                <el-table-column
                    :show-overflow-tooltip='true'
                    align='center'
                    prop='releaseRatio'
                    label='释放比例'
                    width='180'
                ></el-table-column>
                <el-table-column
                    :show-overflow-tooltip='true'
                    align='center'
                    prop='intervalHour'
                    label='隔间小时数'
                    width='180'
                ></el-table-column>
                <el-table-column
                    :show-overflow-tooltip='true'
                    align='center'
                    prop='releaseTo'
                    label='释放到哪个货币类型里面'
                    width='180'
                >
                    <template scope='scope'>
                        <div>{{ currencyTypeStatusString(scope.row.releaseTo) }}</div>
                    </template>
                </el-table-column>
                <el-table-column
                    fixed='right'
                    align='center'
                    label='操作'
                    width='300'
                >
                    <template slot-scope='scop'>
                        <div class='operation'>
                            <div @click='checkMppCurrency(scop.row.id)'>
                                <Icon size='16'>
                                    <Eye24Regular />
                                </Icon>
                                <span class='operation-label'>查看</span>
                            </div>
                            <div @click='editMppCurrency(scop.row.id)'>
                                <Icon size='16'>
                                    <Edit24Regular />
                                </Icon>
                                <span class='operation-label'>修改</span>
                            </div>
                            <div @click='deleteMppCurrency(scop.row.id)'>
                                <Icon size='16' style='color: red'>
                                    <Delete24Regular />
                                </Icon>
                                <span class='operation-label' style='color: red'>删除</span>
                            </div>
                        </div>
                    </template>
                </el-table-column>
            </el-table>
            <div class='pagination-box'>
                <el-pagination
                    @size-change='sizeChange'
                    @current-change='currentChange'
                    :current-page.sync='currentPage'
                    :page-sizes='[10, 20, 50, 100]'
                    :page-size='pageSize'
                    layout='total, sizes, prev, pager, next, jumper'
                    :total='totalNum'
                    background
                    :pager-count='7'
                >
                </el-pagination>
            </div>
            <!-- 新增/查看/修改信息 -->
            <el-dialog
                :title='mppCurrencyStates[mppCurrencyState]'
                :visible.sync='showDialog'
                width='60%'
                @close='closeDialog'
            >
                <div>
                    <el-form
                        :model='mppCurrency'
                        ref='mppCurrencyForm'
                        :rules='rules'
                        label-width='120px'
                        :inline='true'
                        size='small'
                    >
                        <!-- <el-form-item
                            label='货币名称'
                            prop='currencyName'
                        >
                            <el-input
                                size='small'
                                style='width: 200px;'
                                v-model='mppCurrency.currencyName'
                                :disabled="mppCurrencyState == 'check'"
                                placeholder='请输入货币名称'
                            ></el-input>
                        </el-form-item> -->
                        <el-form-item
                            label='货币名称'
                            prop='currencyType'
                        >
                            <el-select
                                style='width: 200px;'
                                v-model='mppCurrency.currencyType'
                                size='small'
                                placeholder='请选货币名称'
                                :disabled="mppCurrencyState == 'check'"
                            >
                                <el-option v-for='(item,index) in currencyTypeEnumList' :label='item.value'
                                           :value='item.key'></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item
                            label='币货汇率'
                            prop='currencyRatio'
                        >
                            <el-input
                                size='small'
                                style='width: 200px;'
                                v-model='mppCurrency.currencyRatio'
                                :disabled="mppCurrencyState == 'check'"
                                placeholder='请输入币货汇率'
                            ></el-input>
                        </el-form-item>
                        <el-form-item
                            label='币货单位'
                            prop='currencyUnit'
                        >
                            <el-input
                                size='small'
                                style='width: 200px;'
                                v-model='mppCurrency.currencyUnit'
                                :disabled="mppCurrencyState == 'check'"
                                placeholder='请输入币货单位'
                            ></el-input>
                        </el-form-item>
                        <el-form-item
                            label='可以充值'
                            prop='canRecharge'
                        >
                            <el-select
                                style='width: 200px;'
                                v-model='mppCurrency.canRecharge'
                                size='small'
                                placeholder='请选择是否可以充值'
                                :disabled="mppCurrencyState == 'check'"
                            >
                                <el-option v-for='(item,index) in yesNoEnumList' :label='item.value'
                                           :value='item.key'></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item
                            label='可以提现'
                            prop='canWithdraw'
                        >
                            <el-select
                                style='width: 200px;'
                                v-model='mppCurrency.canWithdraw'
                                size='small'
                                placeholder='请选择是否可以体现'
                                :disabled="mppCurrencyState == 'check'"
                            >
                                <el-option v-for='(item,index) in yesNoEnumList' :label='item.value'
                                           :value='item.key'></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item
                            label='可以支付'
                            prop='canPay'
                        >
                            <el-select
                                style='width: 200px;'
                                v-model='mppCurrency.canPay'
                                size='small'
                                placeholder='请选择是否可以支付'
                                :disabled="mppCurrencyState == 'check'"
                            >
                                <el-option v-for='(item,index) in yesNoEnumList' :label='item.value'
                                           :value='item.key'></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item
                            label='可以转账'
                            prop='canTransfer'
                        >
                            <el-select
                                style='width: 200px;'
                                v-model='mppCurrency.canTransfer'
                                size='small'
                                placeholder='请选择是否可以转账'
                                :disabled="mppCurrencyState == 'check'"
                            >
                                <el-option v-for='(item,index) in yesNoEnumList' :label='item.value'
                                           :value='item.key'></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item
                            label='可以收款'
                            prop='canAccept'
                        >
                            <el-select
                                style='width: 200px;'
                                v-model='mppCurrency.canAccept'
                                size='small'
                                placeholder='请选择是否可以收款'
                                :disabled="mppCurrencyState == 'check'"
                            >
                                <el-option v-for='(item,index) in yesNoEnumList' :label='item.value'
                                           :value='item.key'></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item
                            label='可以兑出'
                            prop='canSwapout'
                        >
                            <el-select
                                style='width: 200px;'
                                v-model='mppCurrency.canSwapout'
                                size='small'
                                placeholder='请选择是否可以兑出'
                                :disabled="mppCurrencyState == 'check'"
                            >
                                <el-option v-for='(item,index) in yesNoEnumList' :label='item.value'
                                           :value='item.key'></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item
                            label='可以兑入'
                            prop='canSwapin'
                        >
                            <el-select
                                style='width: 200px;'
                                v-model='mppCurrency.canSwapin'
                                size='small'
                                placeholder='请选择是否可以兑入'
                                :disabled="mppCurrencyState == 'check'"
                            >
                                <el-option v-for='(item,index) in yesNoEnumList' :label='item.value'
                                           :value='item.key'></el-option>
                            </el-select>
                        </el-form-item>




                        <el-form-item
                            label='显示结算'
                            prop='showSettle'
                        >
                            <el-select
                                style='width: 200px;'
                                v-model='mppCurrency.showSettle'
                                size='small'
                                placeholder='请选择是否可以显示结算'
                                :disabled="mppCurrencyState == 'check'"
                            >
                                <el-option v-for='(item,index) in yesNoEnumList' :label='item.value'
                                           :value='item.key'></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item
                            label='显示记录'
                            prop='showRecord'
                        >
                            <el-select
                                style='width: 200px;'
                                v-model='mppCurrency.showRecord'
                                size='small'
                                placeholder='请选择是否可以显示记录'
                                :disabled="mppCurrencyState == 'check'"
                            >
                                <el-option v-for='(item,index) in yesNoEnumList' :label='item.value'
                                           :value='item.key'></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item
                            label='显示流水'
                            prop='showFlow'
                        >
                            <el-select
                                style='width: 200px;'
                                v-model='mppCurrency.showFlow'
                                size='small'
                                placeholder='请选择是否可以可以显示流水'
                                :disabled="mppCurrencyState == 'check'"
                            >
                                <el-option v-for='(item,index) in yesNoEnumList' :label='item.value'
                                           :value='item.key'></el-option>
                            </el-select>
                        </el-form-item>




                        <el-form-item
                            label='提现手续费'
                            prop='withdrawServicefee'
                        >
                            <el-input
                                size='small'
                                style='width: 200px;'
                                v-model='mppCurrency.withdrawServicefee'
                                :disabled="mppCurrencyState == 'check'"
                                placeholder='请输入提现手续费'
                            ></el-input>
                        </el-form-item>
                        <el-form-item
                            label='提现限制'
                            prop='withdrawLimit'
                        >
                            <el-input
                                size='small'
                                style='width: 200px;'
                                v-model='mppCurrency.withdrawLimit'
                                :disabled="mppCurrencyState == 'check'"
                                placeholder='请输入提现限制'
                            ></el-input>
                        </el-form-item>
                        <el-form-item
                            label='转出手续费'
                            prop='transferServicefee'
                        >
                            <el-input
                                size='small'
                                style='width: 200px;'
                                v-model='mppCurrency.transferServicefee'
                                :disabled="mppCurrencyState == 'check'"
                                placeholder='请输入转出手续费'
                            ></el-input>
                        </el-form-item>
                        <el-form-item
                            label='转出限制'
                            prop='transferLimit'
                        >
                            <el-input
                                size='small'
                                style='width: 200px;'
                                v-model='mppCurrency.transferLimit'
                                :disabled="mppCurrencyState == 'check'"
                                placeholder='请输入转出限制'
                            ></el-input>
                        </el-form-item>
                        <el-form-item
                            label='兑换手续费'
                            prop='swapServicefee'
                        >
                            <el-input
                                size='small'
                                style='width: 200px;'
                                v-model='mppCurrency.swapServicefee'
                                :disabled="mppCurrencyState == 'check'"
                                placeholder='请输入兑换手续费'
                            ></el-input>
                        </el-form-item>
                        <el-form-item
                            label='兑换限制'
                            prop='swapLimit'
                        >
                            <el-input
                                size='small'
                                style='width: 200px;'
                                v-model='mppCurrency.swapLimit'
                                :disabled="mppCurrencyState == 'check'"
                                placeholder='请输入兑换限制'
                            ></el-input>
                        </el-form-item>
                        <el-form-item
                            label='字段名称'
                            prop='fieldName'
                        >
                            <el-input
                                size='small'
                                style='width: 200px;'
                                v-model='mppCurrency.fieldName'
                                :disabled="mppCurrencyState == 'check'"
                                placeholder='请输入字段名称'
                            ></el-input>
                        </el-form-item>
                        <el-form-item
                            label='是否需释放'
                            prop='isRelease'
                        >
                            <el-select
                                style='width: 200px;'
                                v-model='mppCurrency.isRelease'
                                size='small'
                                placeholder='请选择是否需释放'
                                :disabled="mppCurrencyState == 'check'"
                            >
                                <el-option v-for='(item,index) in yesNoEnumList' :label='item.value'
                                           :value='item.key'></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item
                            label='释放模式'
                            prop='releaseMode'
                            v-if='mppCurrency.isRelease'
                        >
                            <el-select
                                style='width: 200px;'
                                v-model='mppCurrency.releaseMode'
                                size='small'
                                placeholder='请选择释放模式'
                                :disabled="mppCurrencyState == 'check'"
                            >
                                <el-option v-for='(item,index) in releaseModeEnumList' :key='index' :label='item.value'
                                           :value='item.key'>
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item
                            label='释放比例'
                            prop='releaseRatio'
                            v-if='mppCurrency.isRelease'
                        >
                            <el-input
                                size='small'
                                style='width: 200px;'
                                v-model='mppCurrency.releaseRatio'
                                :disabled="mppCurrencyState == 'check'"
                                placeholder='请输入释放比例'
                            ></el-input>
                        </el-form-item>
                        <el-form-item
                            label='隔间小时数'
                            prop='intervalHour'
                            v-if='mppCurrency.isRelease'
                        >
                            <el-input
                                size='small'
                                style='width: 200px;'
                                v-model='mppCurrency.intervalHour'
                                :disabled="mppCurrencyState == 'check'"
                                placeholder='请输入隔间小时数'
                            ></el-input>
                        </el-form-item>
                        <el-form-item
                            label='释放到哪里'
                            prop='releaseTo'
                            v-if='mppCurrency.isRelease'
                        >
                            <el-select
                                style='width: 200px;'
                                v-model='mppCurrency.releaseTo'
                                size='small'
                                placeholder='请选择释放到的货币'
                                :disabled="mppCurrencyState == 'check'"
                            >
                                <el-option v-for='(item,index) in currencyTypeEnumList' :label='item.value'
                                           :value='item.key'></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item
                            label='货币logo'
                            prop='currencyLogo'
                        >
                            <el-upload style='width: 200px;' class='avatar-uploader' action='' :show-file-list='false'
                                       :http-request='uploadAvatar' :disabled="mppCurrencyState == 'check'">
                                <img v-if='mppCurrency.currencyLogo' :src='mppCurrency.currencyLogo' class='avatar'
                                     size='small' />
                                <i v-else class='el-icon-plus avatar-uploader-icon'></i>
                            </el-upload>
                        </el-form-item>
                    </el-form>
                </div>

                <div
                    slot='footer'
                    class='flex justify-end'
                >
                    <el-button @click='closeDialog'>关闭</el-button>
                    <el-button
                        type='primary'
                        @click='submitForm'
                        v-if="mppCurrencyState != 'check'"
                    >确定
                    </el-button>
                </div>
            </el-dialog>
        </div>
    </div>
</template>

<script>
import { ArrowDownload24Regular, ArrowExportUp24Regular } from '@v2icons/fluent';
import { GridDots, Refresh, Printer, ArrowUp, ArrowDown, Search } from '@v2icons/tabler';
import { Edit24Regular, Delete24Regular, Eye24Regular } from '@v2icons/fluent';
import { exprotExcel, importTemplate, importDate, get, post, put, deleteFun, upload } from '@/utils/request.js';
import { UPLOAD_PATH } from '@/utils/constant.js';

export default {
    components: {
        Edit24Regular,
        Delete24Regular,
        Eye24Regular,
        GridDots,
        Refresh,
        Printer,
        ArrowUp,
        ArrowDown,
        ArrowDownload24Regular,
        ArrowExportUp24Regular,
        Search
    },
    watch: {
        checkState(val) {
            if (val == 'check') {
                this.resetMppCurrencyList();
                this.getMppCurrencyList(this.queryForm);
                this.$emit('resetCheckState');
            } else if (val == 'reset') {
                this.resetMppCurrencyList();
                this.getMppCurrencyList();
                this.$emit('resetCheckState');
            }
        }
    },
    data() {
        return {
            releaseModeEnumList: [],//release_mode枚举
            currencyTypeEnumList: [],//currency_type枚举
            yesNoEnumList: [],//yes_no枚举
            queryForm: {
                currencyName: '', //货币名称
                currencyLogo: '', //货币logo
                currencyType: '', //货币类型
                currencyRatio: '', //币货汇率
                currencyUnit: '', //币货单位
                canRecharge: '', //可以充值
                canWithdraw: '', //可以提现
                canPay: '', //可以支付
                canTransfer: '', //可以转账
                canAccept: '', //可以收款
                canSwapout: '', //可以兑出
                canSwapin: '', //可以兑入
                showSettle:'',
                showRecord:'',
                showFlow:'',
                withdrawServicefee: '', //提现手续费
                withdrawLimit: '', //提现限制
                transferServicefee: '', //转出手续费
                transferLimit: '', //转出限制
                swapServicefee: '', //兑换手续费
                swapLimit: '', //兑换限制
                fieldName: '', //字段名称
                isRelease: '', //是否是释放货币
                intervalHour: '', //隔间小时数
                releaseTo: '', //释放到哪个货币类型里面
                releaseMode: '', //释放模式
                releaseRatio: '', //释放比例
            },
            loading: false,
            showDialog: false,
            isImportDate: false,
            isSearch: false,
            pageSize: 10,
            currentPage: 1,
            totalNum: 0,
            currentUserId: '',
            mppCurrencyState: 'add',
            mppCurrencyStates: {
                add: '新建货币',
                check: '查看货币',
                edit: '修改货币'
            },

            multipleSelection: [],
            mppCurrencyList: [],
            mppCurrency: {
                currencyName: '', //货币名称
                currencyLogo: '', //货币logo
                currencyType: '', //货币类型
                currencyRatio: '', //币货汇率
                currencyUnit: '', //币货单位
                canRecharge: '', //可以充值
                canWithdraw: '', //可以提现
                canPay: '', //可以支付
                canTransfer: '', //可以转账
                canAccept: '', //可以收款
                canSwapout: '', //可以兑出
                canSwapin: '', //可以兑入
                showSettle:'',
                showRecord:'',
                showFlow:'',
                withdrawServicefee: '', //提现手续费
                withdrawLimit: '', //提现限制
                transferServicefee: '', //转出手续费
                transferLimit: '', //转出限制
                swapServicefee: '', //兑换手续费
                swapLimit: '', //兑换限制
                fieldName: '', //字段名称
                isRelease: '', //是否是释放货币
                intervalHour: '', //隔间小时数
                releaseTo: '', //释放到哪个货币类型里面
                releaseMode: 1, //释放模式
                releaseRatio: '', //释放比例
            },
            btnLoading: false,

            rules: {
                currencyName: [{ required: true, message: '货币名称不能为空', trigger: 'blur' }],
                currencyLogo: [{ required: true, message: '货币logo不能为空', trigger: 'blur' }],
                currencyType: [{ required: true, message: '货币类型不能为空', trigger: 'blur' }],
                currencyRatio: [{ required: true, message: '币货汇率不能为空', trigger: 'blur' }],
                currencyUnit: [{ required: true, message: '币货单位不能为空', trigger: 'blur' }],
                canRecharge: [{ required: true, message: '可以充值不能为空', trigger: 'blur' }],
                canWithdraw: [{ required: true, message: '可以提现不能为空', trigger: 'blur' }],
                canPay: [{ required: true, message: '可以支付不能为空', trigger: 'blur' }],
                canTransfer: [{ required: true, message: '可以转账不能为空', trigger: 'blur' }],
                canAccept: [{ required: true, message: '可以收款不能为空', trigger: 'blur' }],
                canSwapout: [{ required: true, message: '可以兑出不能为空', trigger: 'blur' }],
                canSwapin: [{ required: true, message: '可以兑入不能为空', trigger: 'blur' }],
                showFlow: [{ required: true, message: '显示流水不能为空', trigger: 'blur' }],
                showRecord: [{ required: true, message: '显示记录不能为空', trigger: 'blur' }],
                showSettle: [{ required: true, message: '显示结算不能为空', trigger: 'blur' }],
                withdrawServicefee: [{ required: true, message: '提现手续费不能为空', trigger: 'blur' }],
                withdrawLimit: [{ required: true, message: '提现限制不能为空', trigger: 'blur' }],
                transferServicefee: [{ required: true, message: '转出手续费不能为空', trigger: 'blur' }],
                transferLimit: [{ required: true, message: '转出限制不能为空', trigger: 'blur' }],
                swapServicefee: [{ required: true, message: '兑换手续费不能为空', trigger: 'blur' }],
                swapLimit: [{ required: true, message: '兑换限制不能为空', trigger: 'blur' }],
                fieldName: [{ required: true, message: '字段名称不能为空', trigger: 'blur' }],
                isRelease: [{ required: true, message: '是否是释放货币不能为空', trigger: 'blur' }],
                intervalHour: [{ required: true, message: '隔间小时数不能为空', trigger: 'blur' }],
                releaseTo: [{ required: true, message: '释放到哪个货币类型里面不能为空', trigger: 'blur' }],
                releaseMode: [{ required: true, message: '释放模式不能为空', trigger: 'blur' }],
                releaseRatio: [{ required: true, message: '释放比例不能为空', trigger: 'blur' }],
            },
            srcList: ['']//大图预览
        };
    },
    created() {
        this.getMppCurrencyList();
        this.getYesNo();
        this.getCurrencyType();
        this.getReleaseMode();
    },
    methods: {
        search() {
            this.isSearch = !this.isSearch;
        },
        updateSrcList(src) {
            this.srcList[0] = src;
        },
        resetMppCurrencyList() {
            this.pageSize = 10;
            this.currentPage = 1;
            this.mppCurrencyList = [];
        },
        resetDialog() {
            this.mppCurrencyState = 'add';
            this.showDialog = false;
            this.queryForm = {
                currencyName: '', //货币名称
                currencyLogo: '', //货币logo
                currencyType: '', //货币类型
                currencyRatio: '', //币货汇率
                currencyUnit: '', //币货单位
                canRecharge: '', //可以充值
                canWithdraw: '', //可以提现
                canPay: '', //可以支付
                canTransfer: '', //可以转账
                canAccept: '', //可以收款
                canSwapout: '', //可以兑出
                canSwapin: '', //可以兑入
                showSettle:'',
                showRecord:'',
                showFlow:'',
                withdrawServicefee: '', //提现手续费
                withdrawLimit: '', //提现限制
                transferServicefee: '', //转出手续费
                transferLimit: '', //转出限制
                swapServicefee: '', //兑换手续费
                swapLimit: '', //兑换限制
                fieldName: '', //字段名称
                isRelease: '', //是否是释放货币
                intervalHour: '', //隔间小时数
                releaseTo: '', //释放到哪个货币类型里面
                releaseMode: '', //释放模式
                releaseRatio: '', //释放比例
            };
            this.getMppCurrencyList();
        },
        closeDialog() {
            this.showDialog = false;
            this.mppCurrency = {
                currencyName: '', //货币名称
                currencyLogo: '', //货币logo
                currencyType: '', //货币类型
                currencyRatio: '', //币货汇率
                currencyUnit: '', //币货单位
                canRecharge: '', //可以充值
                canWithdraw: '', //可以提现
                canPay: '', //可以支付
                canTransfer: '', //可以转账
                canAccept: '', //可以收款
                canSwapout: '', //可以兑出
                canSwapin: '', //可以兑入
                showSettle:'',
                showRecord:'',
                showFlow:'',
                withdrawServicefee: '', //提现手续费
                withdrawLimit: '', //提现限制
                transferServicefee: '', //转出手续费
                transferLimit: '', //转出限制
                swapServicefee: '', //兑换手续费
                swapLimit: '', //兑换限制
                fieldName: '', //字段名称
                isRelease: '', //是否是释放货币
                intervalHour: '', //隔间小时数
                releaseTo: '', //释放到哪个货币类型里面
                releaseMode: 1, //释放模式
                releaseRatio: '', //释放比例
            };
        },
        submitForm() {
            if (this.mppCurrencyState == 'add') {
                this.$refs.mppCurrencyForm.validate((valid) => {
                    if (valid) {
                        console.log('submit');
                        post(`/mpp/mppcurrency/add`, { ...this.mppCurrency }).then((res) => {
                            if (res.success) {
                                this.$message({
                                    message: res.msg,
                                    type: 'success',
                                    duration: 2000
                                });
                                this.resetMppCurrencyList();
                                this.resetDialog();
                            }
                        });
                    }
                });
            } else if (this.mppCurrencyState == 'edit') {
                this.$refs.mppCurrencyForm.validate((valid) => {
                    if (valid) {
                        console.log('submit');
                        post(`/mpp/mppcurrency/edit`, { ...this.mppCurrency }).then((res) => {
                            if (res.success) {
                                this.$message({
                                    message: res.msg,
                                    type: 'success',
                                    duration: 2000
                                });
                                this.resetMppCurrencyList();
                                this.resetDialog();
                            }
                        });
                    }
                });
            }
        },
        addMppCurrency() {
            this.showDialog = true;
            this.mppCurrencyState = 'add';
        },
        checkMppCurrency(mppCurrencyId) {
            console.log(mppCurrencyId);
            this.currentMppCurrencyId = mppCurrencyId;

            this.getMppCurrencyById();
            this.showDialog = true;
            this.mppCurrencyState = 'check';
        },
        editMppCurrency(mppCurrencyId) {
            console.log('mppCurrency', mppCurrencyId);
            if (mppCurrencyId) {
                this.currentMppCurrencyId = mppCurrencyId;
                this.getMppCurrencyById();
            } else {
                this.mppCurrency = { ...this.mppCurrency, ...this.multipleSelection[0] };
            }

            this.showDialog = true;
            this.mppCurrencyState = 'edit';
        },
        deleteMppCurrency(mppCurrencyId) {
            let ids = '';
            if (mppCurrencyId) {
                ids = mppCurrencyId;
            } else {
                ids = this.multipleSelection.map((mppCurrency) => mppCurrency.id).join(',');
            }
            console.log({ ids });
            this.$confirm('确定删除所选项吗？', '提示', {
                type: 'warning'
            })
                .then(() => {
                    deleteFun(`/mpp/mppcurrency/delete`, { ids }).then((res) => {
                        if (res.success) {
                            this.$message({
                                message: res.msg,
                                type: 'success',
                                duration: 2000
                            });
                            this.resetMppCurrencyList();
                            this.getMppCurrencyList();
                        }
                    });
                })
                .catch(() => {
                });
        },
        refreshMppCurrencyList() {
            this.resetMppCurrencyList();
            this.getMppCurrencyList();
        },
        getMppCurrencyList(query = {}) {
            this.loading = true;
            get(`/mpp/mppcurrency/findList`, {
                ...this.queryForm,
                pageNum: this.currentPage,
                pageSize: this.pageSize
            }).then((res) => {
                this.loading = false;
                if (res.success) {
                    this.mppCurrencyList = res.page.list;
                    this.totalNum = res.page.total;
                }
            });
        },
        getMppCurrencyById() {
            get(`/mpp/mppcurrency/get`, { id: this.currentMppCurrencyId }).then((res) => {
                if (res.success) {
                    this.mppCurrency = { ...this.mppCurrency, ...res.mppCurrency };
                }
            });
        },
        /**
         * 导出信息
         */
        exportMppCurrencyList() {
            //this.btnLoading = true;
            exprotExcel(`/mpp/mppcurrency/export`, { ...this.queryForm });
        },
        /**
         * 导出模板
         */
        importTemplate() {
            this.btnLoading = true;
            importTemplate(`/mpp/mppcurrency/importTemplate`, this.btnLoading);
        },
        /**
         * 导入数据
         */
        isImport() {
            this.isImportDate = !this.isImportDate;
        },
        upload(params) {
            const file = params.file;
            const formData = new FormData();
            formData.append('file', file);
            console.log({ formData });
            importDate(`/mpp/mppcurrency/importData`, formData);
            this.refreshMppCurrencyList();
        },
        handleSelectionChange(value) {
            console.log(value);
            this.multipleSelection = value;
        },
        currentChange(page) {
            this.currentPage = page;
            this.getMppCurrencyList();
        },
        sizeChange(size) {
            this.pageSize = size;
            this.getMppCurrencyList();
        },

        //上传缩略图
        uploadAvatar(params) {
            const file = params.file;
            let types = ['image/jpeg', 'image/png', 'image/jpg', 'image/gif'];
            if (!types.includes(file.type)) {
                this.$message.error('图片类型错误!');
            }
            const formData = new FormData();
            formData.append('file', file);
            console.log({ formData });
            upload(UPLOAD_PATH, formData).then((res) => {
                if (res.success) {
                    this.mppCurrency.currencyLogo = res.url;
                    console.log(this.mppCurrency.currencyLogo);
                }
            });
        },

        // 获取yes-no枚举
        getYesNo() {
            get('/mpp/utils/getEnum', {
                enumType: 'yes_no'
            }).then((res) => {
                this.yesNoEnumList = res.enumList;
            });
        },

        //yes_no显示
        yesNoStatusString(key) {
            for (const index in this.yesNoEnumList) {
                if (this.yesNoEnumList[index].key == key) {
                    return this.yesNoEnumList[index].value;
                }
            }
        },

        //获取currency_type枚举
        getCurrencyType() {
            get('/mpp/utils/getEnum', {
                enumType: 'currency_type'
            }).then((res) => {
                this.currencyTypeEnumList = res.enumList;
            });
        },

        //currency_type显示
        currencyTypeStatusString(key) {
            for (const index in this.currencyTypeEnumList) {
                if (this.currencyTypeEnumList[index].key == key) {
                    return this.currencyTypeEnumList[index].value;
                }
            }
        },

        //获取release_mode枚举
        getReleaseMode() {
            get('/mpp/utils/getEnum', {
                enumType:'release_mode'
            }).then((res) => {
                this.releaseModeEnumList = res.enumList;
            });
        },

        //release_mode显示
        releaseModeStatusString(key) {
            for (const index in this.releaseModeEnumList) {
                if (this.releaseModeEnumList[index].key == key) {
                    return this.releaseModeEnumList[index].value;
                }
            }
        },
    }

};
</script>

<style lang='scss' scoped>
::v-deep .el-dialog__header {
  border-bottom: 1px solid #eee;
  padding: 15px 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;

  button {
    display: flex;
    align-items: center;
    justify-content: center;
  }
}

.operation {
    display: flex;
    align-items: center;
    justify-content: center;
    color: #409eff;
    font-size: 12px;

    & > div {
        display: flex;
        align-items: center;
        padding: 0 5px;
        cursor: pointer;
    }

    .operation-label {
        margin-left: 3px;
    }
}


.avatar-uploader .el-upload:hover {
    border-color: #409eff;
}

.avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 200px;
    height: 200px;
    line-height: 200px;
    text-align: center;
}

.avatar {
    width: 200px;
    height: 200px;
    display: block;
}

::v-deep .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
    width: 200px;
    height: 200px;
}

.avatarWide {
    width: 200px;
    height: 120px;
}
</style>
